const FUTURES_GUIDE_MOCK_ID_PREFIX = "futures-guide-mock";
const FUTURES_GUIDE_MOCK_WALLET_ID = "futures-guide-mock-wallet";

const getGuideMockSymbol = (pair) => {
  return String(pair?.symbol || pair?.slug || "BTCUSDT")
    .replace("/", "")
    .toUpperCase();
};

const getGuideMockContext = ({ activeWalletId, pair }) => {
  return {
    symbol: getGuideMockSymbol(pair),
    walletId: activeWalletId || FUTURES_GUIDE_MOCK_WALLET_ID,
    createdAt: new Date().toISOString(),
  };
};

export const getGuideMockPositions = ({ activeWalletId }) => {
  const walletId = activeWalletId || FUTURES_GUIDE_MOCK_WALLET_ID;

  return [
    {
      id: `${FUTURES_GUIDE_MOCK_ID_PREFIX}-position-1`,
      wallet_id: walletId,
      symbol: "ADAUSDT",
      status: "Open",
      cover: null,
      side: "Short",
      type: "market",
      size: "228.00",
      quantity: 1406.5391733498,
      qty: 1406.5391733498,
      amount: 1406.5391733498,
      margin: 6,
      leverage: 38,
      price: "0.1620",
      entry_price: "0.1620",
      fill_price: "0.1620",
      mark_price: "0.1450",
      liq_price: "0.1663",
      pnl: "23.91",
      roi: "398.52",
      closed_price: null,
      created_at: "2026-06-19T14:49:53Z",
      closed_at: null,
      take_profit_trigger_price: null,
      take_profit_triggered_at: null,
      stop_loss_trigger_price: null,
      stop_loss_triggered_at: null,
      isGuideMock: true,
    },
    {
      id: `${FUTURES_GUIDE_MOCK_ID_PREFIX}-position-2`,
      wallet_id: walletId,
      symbol: "SOLUSDT",
      status: "Open",
      cover: null,
      side: "Long",
      type: "market",
      size: "40.00",
      quantity: 0.54661983956708,
      qty: 0.54661983956708,
      amount: 0.54661983956708,
      margin: 20,
      leverage: 2,
      price: "73.177",
      entry_price: "73.177",
      fill_price: "73.177",
      mark_price: "72.8989274",
      liq_price: "36.589",
      pnl: "-0.15",
      roi: "-0.76",
      closed_price: null,
      created_at: "2026-06-17T07:35:03Z",
      closed_at: null,
      take_profit_trigger_price: null,
      take_profit_triggered_at: null,
      stop_loss_trigger_price: null,
      stop_loss_triggered_at: null,
      isGuideMock: true,
    },
    {
      id: `${FUTURES_GUIDE_MOCK_ID_PREFIX}-position-3`,
      wallet_id: walletId,
      symbol: "SOLUSDT",
      status: "Open",
      cover: null,
      side: "Short",
      type: "market",
      size: "40.00",
      quantity: 0.54762263324343,
      qty: 0.54762263324343,
      amount: 0.54762263324343,
      margin: 20,
      leverage: 2,
      price: "73.043",
      entry_price: "73.043",
      fill_price: "73.043",
      mark_price: "72.90056615",
      liq_price: "109.565",
      pnl: "0.08",
      roi: "0.39",
      closed_price: null,
      created_at: "2026-06-17T07:32:36Z",
      closed_at: null,
      take_profit_trigger_price: null,
      take_profit_triggered_at: null,
      stop_loss_trigger_price: null,
      stop_loss_triggered_at: null,
      isGuideMock: true,
    },
  ];
};

export const getGuideMockPositionHistory = ({ activeWalletId, pair }) => {
  const { symbol, walletId, createdAt } = getGuideMockContext({
    activeWalletId,
    pair,
  });

  return [
    {
      id: `${FUTURES_GUIDE_MOCK_ID_PREFIX}-position-history-1`,
      wallet_id: walletId,
      symbol,
      side: "buy",
      status: "Closed",
      quantity: "0.0100",
      qty: "0.0100",
      size: "0.0100",
      amount: "0.0100",
      margin: "68.00",
      leverage: 10,
      price: "68000",
      entry_price: "68000",
      fill_price: "68000",
      close_price: "69200",
      closed_price: "69200",
      pnl: "12.00",
      realized_pnl: "12.00",
      roi: "17.65",
      created_at: createdAt,
      closed_at: createdAt,
      updated_at: createdAt,
      isGuideMock: true,
    },
    {
      id: `${FUTURES_GUIDE_MOCK_ID_PREFIX}-position-history-2`,
      wallet_id: walletId,
      symbol,
      side: "sell",
      status: "Closed",
      quantity: "0.0250",
      qty: "0.0250",
      size: "0.0250",
      amount: "0.0250",
      margin: "86.50",
      leverage: 20,
      price: "69200",
      entry_price: "69200",
      fill_price: "69200",
      close_price: "68400",
      closed_price: "68400",
      pnl: "20.00",
      realized_pnl: "20.00",
      roi: "23.12",
      created_at: createdAt,
      closed_at: createdAt,
      updated_at: createdAt,
      isGuideMock: true,
    },
    {
      id: `${FUTURES_GUIDE_MOCK_ID_PREFIX}-position-history-3`,
      wallet_id: walletId,
      symbol,
      side: "buy",
      status: "Closed",
      quantity: "0.0500",
      qty: "0.0500",
      size: "0.0500",
      amount: "0.0500",
      margin: "675.00",
      leverage: 5,
      price: "67500",
      entry_price: "67500",
      fill_price: "67500",
      close_price: "66800",
      closed_price: "66800",
      pnl: "-35.00",
      realized_pnl: "-35.00",
      roi: "-5.19",
      created_at: createdAt,
      closed_at: createdAt,
      updated_at: createdAt,
      isGuideMock: true,
    },
  ];
};
